export default __webpack_public_path__ + "static/media/cover_placeholder_2x.adf901c5.webp";